"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowALeftIcon24Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowALeftIcon24Regular = forwardRef_1.forwardRef('ArrowALeftIcon24Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M10.556 19.256a.875.875 0 1 1-1.237 1.238L3.035 14.21a3.125 3.125 0 0 1 0-4.42l6.284-6.284a.875.875 0 0 1 1.237 1.238l-6.284 6.284c-.031.031-.06.064-.088.097H21a.875.875 0 1 1 0 1.75H4.184c.028.034.057.066.088.097l6.284 6.284Z" })));
});
